import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Typography } from '@dev/ee-components';

import { ApplicationState } from '@/store';
import { statusNamesMapper } from '../AnalyticsGraph';

export const CustomTooltip = (props: any): JSX.Element => {
    const { t } = useTranslation();
    const { validationStatus } = useSelector((state: ApplicationState) => state.contacts);
    const statusNames = statusNamesMapper();

    if (!props[0]) return null;

    const percent = `${(props[0] && ((props[0]?.value || 0) / (validationStatus?.Contacts || 1)) * 100).toFixed(
        0
    )}%`;

    let description: string;

    switch (props[0].name) {
        case 'ActiveCount':
            description = t('activedesc');
            break;
        case 'AbuseCount':
            description = t('complaintdesc');
            break;
        case 'InactiveCount':
            description = t('inactivedesc');
            break;
        case 'StaleCount':
            description = t('staledesc');
            break;
        case 'UnsubscribeCount':
            description = t('unsubscribeddesc');
            break;
        case 'TransactionalCount':
            description = t('transactionaldesc');
            break;
        case 'BouncedCount':
            description = t('invaliddesc');
            break;
        case 'NotUploadedDuplicatedCount':
            description = t('duplicateddesc');
            break;
        case 'NotUploadedSyntaxCount':
            description = t('incorrectcontactdesc');
            break;
        default:
            description = '';
            break;
    }

    return (
        <div style={{ maxWidth: '230px' }}>
            <Typography variant="h3">{statusNames[props[0]?.name]}</Typography>
            <Typography variant="h2">{props[0]?.value}</Typography>
            <Typography variant="body1" bodyVariant="help">
                {percent}
            </Typography>
            <hr />
            <Typography variant="body1" bodyVariant="help">
                {description}
            </Typography>
        </div>
    );
};